// === Mengenrabatt-Tabellen, gruppiert nach Karat (Gold) bzw. Material ===
// Wichtig: Mit `var` deklariert, damit andere Configurator-Scripts darauf zugreifen können.
// (Frühere Version war ein implizites Global, das im Strict Mode crashen würde.)
var discountMap = {
    // === 10 Karat (identisch zu 14ct) ===
    '10': {
        1: 0,
        2: 6,
        3: 9,
        4: 11,
        5: 14,
        6: 16,
        7: 18,
        8: 20,
        9: 22,
        10: 24,
        11: 25,
        12: 26,
        13: 27,
        14: 28,
        15: 29,
        16: 29.55,
    },
    '14': {
        1: 0,
        2: 9,
        3: 14,
        4: 16,
        5: 13,
        6: 23,
        7: 11,
        8: 17,
        9: 14,
        10: 14,
        11: 15,
        12: 18,
        13: 17,
        14: 14,
        15: 17,
        16: 18,
    },
    '18': {
        1: 0,
        2: 5,
        3: 9,
        4: 7,
        5: 10,
        6: 11,
        7: 11,
        8: 11,
        9: 12,
        10: 12,
        11: 12,
        12: 13,
        13: 12,
        14: 12,
        15: 12,
        16: 13,
    },
    'chrom': {
        1: 0,
        2: 20,
        3: 33,
        4: 40,
        5: 46,
        6: 52,
        7: 52,
        8: 54,
        9: 58,
        10: 61,
        11: 63,
        12: 65,
        13: 66,
        14: 66,
        15: 66,
        16: 66,
    },
    'silber': {
        1: 0,
        2: 16,
        3: 37,
        4: 48,
        5: 49,
        6: 50,
        7: 50,
        8: 50,
        9: 50,
        10: 61,
        11: 64,
        12: 67,
        13: 67,
        14: 67,
        15: 67,
        16: 67,
    },
};

// === Monotonie-Wächter ===
// Problem: Wenn der Rabatt von Stufe n auf n+1 zu stark springt (z.B. Silber
// 9 Zähne = 50% → 10 Zähne = 61%), wird der GESAMTPREIS mit mehr Zähnen
// niedriger – das darf nie passieren.
// Lösung: Jede Tabelle wird beim Laden so gedeckelt, dass gilt:
//   Gesamtpreis(n+1) >= Gesamtpreis(n)
// Formel: n*(1-d(n)/100) muss monoton steigen. Überschreitet ein Tabellenwert
// das erlaubte Maximum, wird er auf den Grenzwert geklemmt (Preis bleibt dann
// exakt gleich statt zu sinken).
function sanitizeDiscountTable(table){
    const out={};
    let prevTotalFactor=0; // n*(1-d/100) der Vorstufe
    for(let n=1;n<=16;n++){
        let d=table[n]??0;
        let totalFactor=n*(1-d/100);
        if(totalFactor<prevTotalFactor){
            // Abrunden (floor), damit der geklemmte Rabatt die Grenze nie überschreitet
            d=Math.floor((1-prevTotalFactor/n)*100*100)/100;
            totalFactor=n*(1-d/100);
        }
        out[n]=d;
        prevTotalFactor=totalFactor;
    }
    return out;
}

for(const key of Object.keys(discountMap)){
    discountMap[key]=sanitizeDiscountTable(discountMap[key]);
}
